// extracted by mini-css-extract-plugin
module.exports = {"content":"PopoverBox_content__IljjI","userNameList":"PopoverBox_userNameList__2Cqmt"};